var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#E85298",
  clipPath: "url(#icon_time_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 20a10 10 0 1 1 10-10 10.01 10.01 0 0 1-10 10Zm0-18.18A8.18 8.18 0 1 0 18.18 10 8.19 8.19 0 0 0 10 1.82Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.86 11.897a.941.941 0 0 1-.554-.182L5.09 8.595A.937.937 0 1 1 6.21 7.09l4.214 3.12a.939.939 0 0 1 .194 1.31.953.953 0 0 1-.756.377Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.654 11.936a.935.935 0 0 1-.615-1.643l5.5-4.8a.94.94 0 0 1 1.232 1.416l-5.5 4.795a.919.919 0 0 1-.617.232Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_time_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#fff",
  rx: 4
})))));
export default SvgIconTime;